import React from "react";
import { Card, CardContent, Typography, Box, makeStyles } from "@material-ui/core";
import { TrendingUp, TrendingDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: 10,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
        border: `1px solid ${theme.palette.mode === "light" ? "#F3F4F6" : "#374151"}`,
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
        },
    },
    iconContainer: {
        width: 56,
        height: 56,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: theme.spacing(2),
    },
    value: {
        fontSize: "2rem",
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: theme.spacing(0.5),
    },
    label: {
        fontSize: "0.875rem",
        fontWeight: 500,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
    },
    changeContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    changeText: {
        fontSize: "0.75rem",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: 4,
    },
    changePositive: {
        color: theme.palette.success.main,
    },
    changeNegative: {
        color: theme.palette.error.main,
    },
    changeIcon: {
        fontSize: "1rem",
    },
}));

const StatCard = ({
    icon: Icon,
    iconColor = "#316AFF",
    iconBgColor = "rgba(49, 106, 255, 0.1)",
    value,
    label,
    change,
    changeLabel = "vs last month",
}) => {
    const classes = useStyles();
    const isPositive = change >= 0;

    return (
        <Card className={classes.root}>
            <CardContent>
                <Box
                    className={classes.iconContainer}
                    style={{
                        backgroundColor: iconBgColor,
                        color: iconColor,
                    }}
                >
                    {Icon && <Icon style={{ fontSize: 28 }} />}
                </Box>

                <Typography className={classes.value} variant="h3">
                    {value}
                </Typography>

                <Typography className={classes.label}>{label}</Typography>

                {change !== undefined && (
                    <Box className={classes.changeContainer}>
                        <Typography
                            className={`${classes.changeText} ${isPositive ? classes.changePositive : classes.changeNegative
                                }`}
                        >
                            {isPositive ? (
                                <TrendingUp className={classes.changeIcon} />
                            ) : (
                                <TrendingDown className={classes.changeIcon} />
                            )}
                            {Math.abs(change)}%
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            {changeLabel}
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default StatCard;
